const larryPhone = process.env.REACT_APP_LARRY_PHONE;
const jasonPhone = process.env.REACT_APP_JASON_PHONE;

// Function to format phone numbers for display
const formatPhoneForDisplay = (phone) => {
  return phone.replace(/\+1(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
};

const isProduction = process.env.REACT_APP_ENV === "production";

const config = {
    larryPhone: {
        raw: larryPhone, // Use for `tel:` links
        display: formatPhoneForDisplay(larryPhone), // Pre-formatted for UI
    },
    jasonPhone: {
        raw: jasonPhone,
        display: formatPhoneForDisplay(jasonPhone),
    },
    contactEmail: process.env.REACT_APP_CONTACT_EMAIL,
    metadata: {
        siteUrl: isProduction ? "https://www.withrowknives.com" : "http://localhost:3000",
        address: {
            state: "West Virginia",
            country: "US"
        },
        serviceArea: {
            "@type": "AdministrativeArea",
            "name": "West Virginia"
        }
    }
};

export default config;
